import { useState } from "react"
import PropTypes from "prop-types"
import FilterButton from "./FilterButton"
import FilterBadgeContent from "./FilterBadgeContent"
import { isBlank } from "utils/helpers"

export const DATE_KIND = "registrationDate"

export const dateBadge = (selected, _options) => {
  return <FilterBadgeContent value={`${selected.value} days ago`} />
}

const DateOptions = ({ onSubmit }) => {
  const [value, setValue] = useState("")

  const handleChange = e => {
    const number = e.target.value.replace(/[^0-9.]/g, "")
    setValue(number)
  }

  const handleSubmit = () => {
    onSubmit({
      value,
      label: dateBadge({ value }),
      kind: DATE_KIND
    })

    setValue("")
  }

  return (
    <>
      <p className="mb-1">Show registrations submitted</p>
      <div>
        in the last
        <input
          type="text"
          value={value}
          onChange={handleChange}
          style={{ height: 32, width: 48, margin: "0 8px" }}
        />
        days
      </div>
      <FilterButton disabled={isBlank(value)} onSubmit={handleSubmit} />
    </>
  )
}

DateOptions.propTypes = {
  onSubmit: PropTypes.func
}

export default DateOptions
